import React, { useEffect } from 'react';
import { initMetaPixel } from './components/metaPixel';
// ==================================================
// SHOPIFY VARIANT IDS & PRICES — edit here to update
// ==================================================
const SHOPIFY_CART_DOMAIN = 'http://impulsodigital.vip/cart/';
const MAIN_PRODUCT_VARIANT_ID = '44791649009750';
const MAIN_PRODUCT_PRICE = 19990;
const UPSELL_PRODUCTS = [{
  id: 'mi-psicologa-me-dijo',
  name: 'MI PSICÓLOGA ME DIJO',
  variantId: '44814228979798',
  offerPrice: 3990,
  benefit: 'Herramientas emocionales para sanar, entender tus pensamientos y volver a elegirte.',
  image: 'https://cdn.magicpatterns.com/uploads/d62a9vdYT3xZ3xcnqZ43BD/d_nq_np_2x_766390-mla87965816554_072025-f-cd3e95bea523bdbb7117576109429829-1024-1024.webp'
}, {
  id: 'dejar-de-pensar-demasiado',
  name: 'CÓMO DEJAR DE PENSAR DEMASIADO',
  variantId: '44814250508374',
  offerPrice: 3990,
  benefit: 'Ideal para calmar la mente, reducir el sobrepensamiento y recuperar claridad.',
  image: 'https://cdn.magicpatterns.com/uploads/dFStQAmB7KDFLUY7V8kpFK/D_NQ_NP_719480-MLA109668186462_042026-O.webp'
}, {
  id: 'tu-eres-tu-prioridad',
  name: 'TÚ ERES TU PRIORIDAD',
  variantId: '44814282588246',
  offerPrice: 3990,
  benefit: 'Una guía para poner límites, priorizarte y dejar de vivir para complacer a otros.',
  image: 'https://cdn.magicpatterns.com/uploads/3nbLQzPeSSyDtubEuQXz7Z/D_NQ_NP_959660-MLA92918380134_092025-O.webp'
}, {
  id: 'si-lo-crees-lo-creas',
  name: 'SI LO CREES, LO CREAS',
  variantId: '44814308016214',
  offerPrice: 3990,
  benefit: 'Refuerza tu mentalidad de manifestación, enfoque y confianza en lo que querés lograr.',
  image: 'https://cdn.magicpatterns.com/uploads/drJrZjzSZ6z1iP6zoHZqHW/50674282.jpg'
}, {
  id: 'merezco-mucho-mas',
  name: 'MEREZCO MUCHO MÁS',
  variantId: '44814347698262',
  offerPrice: 3990,
  benefit: 'Para trabajar merecimiento, autoestima y abrirte a recibir más en tu vida.',
  image: 'https://cdn.magicpatterns.com/uploads/c4q5EVnxZS5or3qeBfNMsD/D_NQ_NP_668701-MLA91823515857_092025-O.webp'
}];
const FULL_PACK_VARIANT_ID = '44814548697174';
const FULL_PACK_PRICE = 9990;
const FULL_PACK_SEPARATE_VALUE = 19950;
// ==================================================
import { CheckoutProvider } from './components/CheckoutContext';
import { StickyCTA } from './components/StickyCTA';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismShift } from './components/MechanismShift';
import { OfferBox } from './components/OfferBox';
import { BonusesSection } from './components/BonusesSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  // Load Meta Pixel once and fire PageView + ViewContent a single time.
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CheckoutProvider cartBaseUrl={SHOPIFY_CART_DOMAIN} mainVariantId={MAIN_PRODUCT_VARIANT_ID} mainPrice={MAIN_PRODUCT_PRICE} upsellProducts={UPSELL_PRODUCTS} fullPackVariantId={FULL_PACK_VARIANT_ID} fullPackPrice={FULL_PACK_PRICE} fullPackSeparateValue={FULL_PACK_SEPARATE_VALUE} data-id="element-0">
      <div className="min-h-screen bg-brand-black text-brand-white pb-24" data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <MechanismShift data-id="element-4" />
        <OfferBox data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <WhatsIncluded data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <Footer data-id="element-12" />
        <StickyCTA data-id="element-13" />
      </div>
    </CheckoutProvider>;
}